import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

const pageTitle = "Emergency Passport Casper, WY — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Fast Passport Center provides emergency, expedited, and same-day passport services in Casper, Wyoming. Serving Natrona County and central Wyoming. As fast as 24 hours — no Denver agency trip needed.";
const casperFaqs = [
  { q: "How do I get an expedited passport in Casper, Wyoming?", a: "Casper residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents overnight and we handle agency submission remotely. The nearest regional agency is in Denver, 300+ miles south." },
  { q: "Where is the nearest passport agency to Casper?", a: "The Denver Regional Passport Agency (3151 S Vaughn Way, Suite 600, Aurora, CO 80014) is 300+ miles south of Casper via I-25. For most Casper residents, the trip is not feasible. Fast Passport Center eliminates that need entirely." },
];

export default function CasperPage() {
  return (
    <>
      <CitySEOHead
        city="Casper"
        state="Wyoming"
        stateAbbr="WY"
        route="/cities/casper"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Casper, Wyoming"
        geoPosition="42.8501;-106.3252"
        keywords="expedited passport Casper, emergency passport Casper WY, same day passport Casper, fast passport Wyoming, passport renewal Casper, Natrona County passport"
        faqs={casperFaqs}
        servicesSchema={[]}
        statePageName="Wyoming"
        statePageRoute="/states/wyoming"
        lastModified="2026-06-09"
        serviceAreaDesc="Expedited and emergency passport services for Casper, WY and Natrona County. As fast as 24 hours. No 300-mile Denver agency trip needed."
      />

      <div className="min-h-screen bg-white">
      <HeroSection />
      <StickyNav />
      <ProcessingTimeSection />
      <ServicesSection />
      <HowItWorksSection />
      <LocalAreaSection />
      <TestimonialsSection />
      <AcceptanceFacilitiesSection />
      <ComparisonSection />
      <MistakesSection />
      <FAQSection />
      <HelpfulResourcesSection />
      <FinalCTA />
      </div>
    </>
  );
}